import { default as ReactSelect } from "react-select";
import { useRef } from "react";
import { useAppContext } from "../_context";

const Select = ({
  id,
  defaultValue = null,
  multiple = false,
  options = [],
  onChange = null,
  placeholder = null,
}) => {
  const [{ tx }] = useAppContext();
  const inputRef = useRef();
  let opts = {};

  const onUserAction = (data) => {
    let value;

    if (multiple) {
      value = JSON.stringify(data.map((item) => item.value));
    } else {
      value = data?.value || data;
    }

    inputRef.current.value = value;

    if (onChange) {
      onChange({ target: { value } });
    }
  };

  const selectStyles = {
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (item) => ({
      ...item,
      color: "#000",
    }),
    control: (items, state) => ({
      ...items,
      padding: "4px 0",
      boxShadow: "none !important",
      borderColor: state.isFocused ? "#1FB0F7 !important" : "#d2d3da",
      borderRadius: "6px",
    }),
  };

  if (!placeholder) {
    placeholder = multiple
      ? tx["You can select multiple options"]
      : tx["Please select one option"];
  }

  if (!multiple) {
    selectStyles.placeholder = (items) => ({
      ...items,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    });
  }

  if (defaultValue) {
    opts.defaultValue = defaultValue;
  }

  return (
    <div className="selector-multiple">
      <ReactSelect
        options={options}
        onChange={onUserAction}
        styles={selectStyles}
        isMulti={multiple}
        isSearchable={multiple}
        placeholder={placeholder}
        closeMenuOnSelect={!multiple}
        {...opts}
      />
      <input ref={inputRef} type="hidden" id={id} />
    </div>
  );
};

export default Select;
